import {useAuth} from "../../authprovider";
import React, {useEffect, useState} from "react";
import {Button, Card, Form, InputGroup, ProgressBar, Table} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilePdf, faTrashCan} from "@fortawesome/free-solid-svg-icons";

export default function FilesCard(props){

    const auth = useAuth();
    const [building] = useState(props['data-building'])
    const [files,setFiles] = useState(undefined);
    const [uploading, setUploading] = useState(false)
    const [progress, setProgress] = useState(0);

    useEffect(()=>{
        if(files !== undefined || !building.id)
            return;

        auth.buildings.getDocuments(building.id + "/documents", response=>{
            const {success, error, content} = response;

            if(success === true){
                setFiles(content)
            } else
                console.log(error)
        })
    })

    const findFile = (id)=>{
        return files.find((val)=>id === val.id);
    }

    const uploadProgressHandler = (event)=>{
        let percent = 0;
        let position = event.loaded || event.position;
        let total = event.total;
        if (event.lengthComputable) {
            percent = Math.ceil(position / total * 100);
        }

        setProgress(percent);
    }

    const uploadFile = (formEvent)=>{
        formEvent.preventDefault();
        formEvent.stopPropagation();

        const form = formEvent.currentTarget;

        if(form.file.files.length <= 0)
            return;

        if(form.type.value.length <= 0)
            return;

        setUploading(true);

        const suffix =  building.id + "/addfile";

        const formData = new FormData();
        formData.append('file', form.file.files[0]);
        formData.append('type', form.type.value);

        auth.buildings.uploadFile(suffix,formData, uploadProgressHandler, response=>{
            const {success, error, content} = response;

            if(success === true){
                setFiles([...files, content])
                form.reset()
            } else {
                console.log(error);
                alert(error)
            }
            setUploading(false);
        } )


    }

    const viewFile = (id)=>{
        const suffix =  "document/download/"+id;

        auth.buildings.download(suffix, response=>{
            const {success, error, content} = response;

            if(success === true){
                viewPdf(content)
            } else {
                alert(error)
            }
        })

    }

    const deleteFile = (id)=>{

        const file = findFile(id)

        if(file === undefined){
            setFiles([...files])
            return;
        }

        if(window.confirm("Potwierdź skasowanie pliku: "+file.name)){

            const suffix = building.id + "/deletefile/"+id;

            auth.buildings.deleteFile(suffix, response=>{
                const {success, error} = response;

                if(success === true){
                    setFiles(files.filter((f)=>f.id !== id))
                } else {
                    alert(error);
                }
            })

        }
    }

    return (
        <div className={"col-12"}>
            <Card className={"m-2"} key={"data"}>
                <Card.Header as={"h5"}>Dokumenty obiektu</Card.Header>
                <Card.Body>
                    <Form  onSubmit={uploadFile} >
                        <div className={"mb-3"}>
                            <InputGroup className="">
                                <Form.Control className={"w-75"} type="file" name={"file"} accept={"application/pdf"} />
                                <Form.Select name={"type"} aria-label="Wybór pliku z dysku">
                                    <option value={""}>Typ pliku</option>
                                    <option value="IBP">Instrukcja PPOŻ</option>
                                    <option value="EVAC">Plany Ewak.</option>
                                    <option value="TRAINING">Szkolenie</option>
                                </Form.Select>
                                <Button name={"Dodaj"} disabled={uploading} type={"submit"} variant="outline-secondary" id="button-addon2">
                                    Dodaj
                                </Button>
                            </InputGroup>
                            <Form.Text id="passwordHelpBlock" muted>
                                Wybierz plik z dysku. Maksymalny dopuszczalny rozmiar pliku: 15 MB
                            </Form.Text>
                        </div>

                        {
                            uploading &&
                            <ProgressBar now={progress} label={`${progress}%`} />
                        }

                    </Form>
                    <Table striped bordered hover>
                        <thead>
                        <tr className={"text-center text-capitalize"}>
                            <th>#</th>
                            <th>Nazwa</th>
                            <th>Typ</th>
                            <th>Rozmiar</th>
                            <th>Akcje</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            files && files.map((file, index)=>{
                                return(
                                    <tr className={"text-center"} key={file.id}>
                                        <td>{index+1}</td>
                                        <td>{file.name}</td>
                                        <td>{file.type}</td>
                                        <td>{Math.round(file.size*10/(1024*1024))/10} MB</td>
                                        <td className={"no-wrap"}>
                                            <Button name={"Podgląd"} variant={"outline-danger"} title={"Podgląd"} onClick={()=>viewFile(file.id)} ><FontAwesomeIcon icon={faFilePdf} /></Button>
                                            <Button name={"Usuń"} className={"ms-2"} title={"Usuń"} variant={"outline-danger"} onClick={()=>deleteFile(file.id)} ><FontAwesomeIcon icon={faTrashCan} /></Button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

        </div>
    )

}

const viewPdf =(blob)=>{
    let newBlob = new Blob([blob], {type:"application/pdf"})
    let objectURL = URL.createObjectURL(newBlob);
    window.open(objectURL,"_blank");
}